import { IClassname } from '@/lib/shared/model/classname';

export const Sauna = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2232 1.61719C25.7301 2.22778 25.4413 2.9779 25.3977 3.76153C25.3977 5.10079 26.2232 6.44516 26.2232 7.7793C26.1799 8.56299 25.8911 9.31318 25.3977 9.92365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3895 1.61719C21.8964 2.22778 21.6076 2.9779 21.564 3.76153C21.564 5.10079 22.3895 6.44516 22.3895 7.7793C22.3461 8.56299 22.0573 9.31318 21.564 9.92365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.057 1.61719C29.5639 2.22778 29.2751 2.9779 29.2314 3.76153C29.2314 5.10079 30.057 6.44516 30.057 7.7793C30.0136 8.56299 29.7248 9.31318 29.2314 9.92365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9455 15.79V29.0932C24.9455 29.4321 24.8109 29.7571 24.5712 29.9968C24.3316 30.2364 24.0065 30.3711 23.6676 30.3711H8.3326C7.99368 30.3711 7.66864 30.2364 7.42898 29.9968C7.18932 29.7571 7.05469 29.4321 7.05469 29.0932V15.79"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8338 30.371V18.2308C19.8338 18.1468 19.8172 18.0638 19.7851 17.9862C19.753 17.9087 19.7059 17.8383 19.6466 17.7789C19.5873 17.7196 19.5168 17.6725 19.4393 17.6404C19.3618 17.6083 19.2787 17.5918 19.1948 17.5918H12.8052C12.6358 17.5918 12.4732 17.6591 12.3534 17.7789C12.2336 17.8988 12.1663 18.0613 12.1663 18.2308V30.371"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2778 21.4258V23.9816"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.057 19.5075L16 9.28418L1.94287 19.5075"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
